// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2kJqz","options":"AnswerScale_options__2yXwf","selected":"AnswerScale_selected__2dE7J"};